import { RouterProvider } from 'react-router-dom'
import { Providers } from './providers'
import { router } from './router/routes'
import { AlertContainer } from '@shared/ui'
import './styles/global.css'

export const App = () => (
  <Providers>
    <RouterProvider router={router} />
    <AlertContainer />
  </Providers>
)
